<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <div>
          <h3 class="card-title">{{$t('applications.applicant__ongoing')}}</h3>
          <card v-if="ongoing.length" v-for="application in ongoing" v-bind:key="application.applicationId">
            <template slot="header">
              <h3 class="card-title">{{ application.description }}</h3>
              <h5 class="card-category">{{$t('applications.general__application_title')}}: <strong>{{application.title}}</strong></h5>
              <h5 class="card-category">{{$t('applications.general__application_reference')}}: <strong>{{application.reference}}</strong></h5>
              <h5 class="card-category">{{$t('general.created_date')}}: {{application.createdAt}}</h5>
              <h5 class="card-category">{{$t('general.last_update')}}: {{application.updatedAt}}</h5>
            </template>
            <base-button @click="goToApplication(application.grantId, application.applicationId)" type="primary" size="lg" simple>{{$t('general.complete')}}</base-button>
          </card>
          <h4 v-if="!ongoing.length" class="card-title">{{$t('applications.applicant__empty_state')}}</h4>
        </div>

        <div>
          <h3 class="card-title">{{$t('applications.applicant__submitted')}}</h3>
          <card v-if="pending.length" v-for="application in pending" v-bind:key="application.applicationId">
            <template slot="header">
              <h3 class="card-title">{{ application.description }}</h3>
              <h5 class="card-category">{{$t('applications.general__application_title')}}: <strong>{{application.title}}</strong></h5>
              <h5 class="card-category">{{$t('applications.general__application_reference')}}: <strong>{{application.reference}}</strong></h5>
              <h5 class="card-category">{{$t('general.submitted_date')}}: {{application.updatedAt}}</h5>
            </template>
            <base-button @click="goToApplication(application.grantId, application.applicationId)" type="primary" size="lg" simple>{{$t('general.view')}}</base-button>
          </card>
          <h4 v-if="!pending.length" class="card-title">{{$t('applications.applicant__empty_state')}}</h4>
        </div>

        <div>
          <h3 class="card-title">{{$t('applications.applicant__awarded')}}</h3>
          <card v-if="awarded.length" v-for="application in awarded" v-bind:key="application.applicationId">
            <template slot="header">
              <h3 class="card-title">{{ application.description }}</h3>
              <h5 class="card-category">{{$t('applications.general__application_title')}}: <strong>{{application.title}}</strong></h5>
              <h5 class="card-category">{{$t('applications.general__application_reference')}}: <strong>{{application.reference}}</strong></h5>
            </template>
            <base-button @click="goToApplication(application.applicationId)" type="primary" size="lg" simple>{{$t('general.view')}}</base-button>
          </card>
          <h4 v-if="!awarded.length" class="card-title">{{$t('applications.applicant__empty_state')}}</h4>
        </div>

        <div>
          <h3 class="card-title">{{$t('applications.applicant__rejected')}}</h3>
          <card v-if="rejected.length" v-for="application in rejected" v-bind:key="application.applicationId">
            <template slot="header">
              <h3 class="card-title">{{ application.description }}</h3>
              <h5 class="card-category">{{$t('applications.general__application_title')}}: <strong>{{application.title}}</strong></h5>
              <h5 class="card-category">{{$t('applications.general__application_reference')}}: <strong>{{application.reference}}</strong></h5>
            </template>
            <base-button @click="goToApplication(application.applicationId)" type="primary" size="lg" simple>{{$t('general.view')}}</base-button>
          </card>
          <h4 v-if="!rejected.length" class="card-title">{{$t('applications.applicant__empty_state')}}</h4>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="row">
          <div class="font-icon-list col-lg-12">
            <div @click="() => $router.push('/grants')" class="font-icon-detail application-button">
              <i class="tim-icons icon-notes"></i>
              <h4>{{ $t('applications.general__apply_for_new') }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {ApplicationService} from '@/services';

  export default {
    data() {
      return {
        initialized: false,
        applications: []
      };
    },
    computed: {
      ongoing() {
        return this.applications.filter(function (application) {
          return application.status == 'draft';
        })
      },
      pending() {
        let filtered = this.applications.filter(function (application) {
          return application.status == 'submitted';
        })

        return this._.orderBy(filtered, 'updatedAt', 'asc')
      },
      awarded() {
        return this.applications.filter(function (application) {
          return application.status == 'awarded';
        })
      },
      rejected() {
        return this.applications.filter(function (application) {
          return application.status == 'rejected';
        })
      }
    },
    methods: {
      goToApplication(grantId, applicationId) {
        this.$router.push('/application/fill/' + grantId + '/' + applicationId);
      },
      async getApplications() {
        let loader = this.$loading.show();
        ApplicationService.getOngoing().then((response) => {
          this.applications = response.data;
          this.initialized = true;
          loader.hide();
        })
      }
    },
    created() {
      this.getApplications();
    }
  };
</script>
<style lang="scss"></style>
